__turbopack_context__.v({
  "description": "JmgZ0G_description",
  "empty": "JmgZ0G_empty",
  "info": "JmgZ0G_info",
  "infoHeader": "JmgZ0G_infoHeader",
  "infoTitle": "JmgZ0G_infoTitle",
  "infoType": "JmgZ0G_infoType",
  "isHidden": "JmgZ0G_isHidden",
});
